import { mobileLargeMax, tabletMax } from '@propertypal/shared/src/constants/mediaQueries';
import { Box } from '@propertypal/web-ui/src/layout';
import styled, { CSSProperties, css } from 'styled-components';

export const FormWrapper = styled.div<{ $mw?: number }>`
  max-width: ${({ $mw }) => $mw || 700}px;
  margin: 0 auto;
  text-align: center;
`;

export const SelectWrapper = styled.div<{ $maxWidth?: number; $mt?: number; $mb?: number }>`
  max-width: ${({ $maxWidth }) => $maxWidth || 700}px;
  margin: ${({ $mt }) => $mt || 0}px auto ${({ $mb }) => $mb || 0}px auto;
  text-align: center;
`;

export const FlexColumn = styled.div`
  width: 50%;
  padding: 15px;

  button {
    margin-top: 19px;
  }

  @media screen and (${mobileLargeMax}) {
    width: 100%;
  }
`;

export const FormContainer = styled.div<{ $maxWidth?: number; $flexDirection?: CSSProperties['flexDirection'] }>`
  display: flex;
  flex-direction: ${({ $flexDirection }) => $flexDirection || 'row'};

  ${({ $maxWidth }) =>
    $maxWidth
      ? css`
          max-width: ${$maxWidth}px;
          margin: 0px auto;
          text-align: center;
        `
      : ''}

  ${({ $flexDirection }) =>
    $flexDirection === 'column'
      ? css`
          ${FlexColumn} {
            width: 100%;
            padding-left: 0;
            padding-right: 0;
          }
        `
      : ''}

  @media screen and (${mobileLargeMax}) {
    flex-direction: column;
  }
`;

export const InputWrapper = styled.div`
  margin-top: 19px;
`;

export const StyledLink = styled.a`
  color: ${({ theme }) => theme.primary};
  text-decoration: underline;

  :hover {
    color: ${({ theme }) => theme.lightGrey};
  }
`;

export const Container = styled(Box)`
  margin: 80px auto;
  @media screen and (${tabletMax}) {
    margin: 40px 0;
  }
`;
